<template>
  <div />
</template>

<script>
/**
 * BootstrapVueのモーダルの重畳を検出するコンポーネント
 */
export default {
  name: 'AppBvModalOverlayDetector',
  data: function () {
    return {
      /**
       * 開いているモーダルの数
       * @type {Number}
       */
      modalCount: 0,
    }
  },
  computed: {
    /**
     * モーダルが重畳している場合はtrue
     * @type {Boolean}
     */
    isOverlaid: function () {
      return this.modalCount > 0
    },
  },
  mounted: function () {
    this.$_setModalToggleEventListener()
  },
  beforeDestroy: function () {
    this.$_removeModalToggleEventListener()
  },
  watch: {
    isOverlaid: function () {
      /**
       * モーダルの重畳状態が変更したときのイベント
       * @param {Boolean} isOverlaid 重畳している場合はtrue
       */
      this.$emit('is-modal-overlaid-changed', this.isOverlaid)
    },
  },
  methods: {
    /**
     * モーダルカウントを増やす
     */
    $_incrementModalCount: function () {
      this.modalCount += 1
    },

    /**
     * モーダルカウントを減らす
     */
    $_decrementModalCount: function () {
      this.modalCount -= 1
    },

    /**
     * モーダルの表示/非表示イベントリスナー設定
     */
    $_setModalToggleEventListener: function () {
      this.$root.$on('bv::modal::shown', this.$_incrementModalCount)
      this.$root.$on('bv::modal::hidden', this.$_decrementModalCount)
    },

    /**
     * モーダルの表示/非表示イベントリスナー解除
     */
    $_removeModalToggleEventListener: function () {
      this.$root.$off('bv::modal::shown', this.$_incrementModalCount)
      this.$root.$off('bv::modal::hidden', this.$_decrementModalCount)
    },
  },
}
</script>
